<dx-data-grid class="fixGridHeight" id="AwardDetailsGrid" [dataSource]="awardDetails" [showRowLines]="true"
    [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true">
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    <dxo-toolbar>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">
            <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
            </dx-button>
            <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                (onClick)="exportExcel($event)">
            </dx-button>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
    </dxo-toolbar>
    <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true" [showInfo]="true"
        [showNavigationButtons]="false"></dxo-pager>

    <dxi-column dataField="competitor" [width]="80"></dxi-column>
    <dxi-column dataField="offeringType" [width]="80"></dxi-column>
    <dxi-column dataField="dealType" [width]="100"></dxi-column>
    <dxi-column dataField="tgeeregions" caption="Region" [width]="80"></dxi-column>
    <dxi-column dataField="country" [width]="80"></dxi-column>
    <dxi-column dataField="announcementTitle" [width]="200"></dxi-column>
    <dxi-column dataField="announcementDate" [width]="80"></dxi-column>
    <dxi-column dataField="onstreamYear" [width]="80"></dxi-column>
    <dxi-column dataField="primaryMaterial" [width]="100"></dxi-column>
    <dxi-column dataField="quantity" [width]="120"> </dxi-column>
    <dxi-column dataField="units" [width]="80"> </dxi-column>
    <dxi-column dataField="totalCostEstimateMmusd" caption="Total Cost Estimate MMUSD" [width]="150">
        <dxo-format type="fixedPoint" [precision]="1">
        </dxo-format>
    </dxi-column>
    <dxi-column dataField="competitorInvestment" caption="Competitor Investment MMUSD" [width]="150">
        <dxo-format type="fixedPoint" [precision]="1">
        </dxo-format>
    </dxi-column>
    <dxi-column dataField="notes" [width]="200"></dxi-column>
    <dxi-column dataField="productionFacilityId" caption="Facility ID" width="100"></dxi-column>
</dx-data-grid>